import { Box, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import SafeMuiDatatable from '../generic_components/SafeMuiDatatable';
import text from './text';
import matchingProfilesColumns from './MatchingProfilesColumns';
import helperFunctions from './utils/helperFunctions';

const muiTheme = {
  overrides: {
    MUIDataTableHeadCell: {
      root: {
        '&:hover': {
          cursor: 'pointer'
        }
      }
    },
    MUIDataTableBodyCell: {
      root: {
        '&:hover': {
          cursor: 'pointer'
        }
      }
    }
  }
};

function getMaxContactDate(candidate) {
  if (candidate.pastContacts.length === 0) {
    return;
  }
  // eslint-disable-next-line consistent-return
  return new Date(Math.max.apply(null, candidate.pastContacts.map(e => new Date(e.contactDate))));
}

const safe = (val, fallback = '') => (val != null ? val : fallback);

/**
 * Maps the date for date table
 * IMPORTANT!: The order of the object have to match the columns def order
 */
const candidateListMapper = data => ({
  id: data._id,
  status:
    helperFunctions.verifyCandidateStatus({
      statusType: data.statusType,
      statusExpirationDate: data.statusExpirationDate
    }).statusType === 'available'
      ? 'verfügbar'
      : 'nicht verfügbar',
  salutation: safe(data.salutation),
  firstName: safe(data.firstName),
  lastName: safe(data.lastName),
  mail: safe(data.mailAddress),
  currentJob: safe(data.currentJob),
  currentCompany: safe(data.currentCompany),
  postalCode: safe(data.postalCode),
  city: safe(data.city),
  birthDate: safe(data.dateOfBirth),
  lastUpdate: data.lastUpdate ? data.lastUpdate.date : '',
  maxContactDate: data.pastContacts && getMaxContactDate(data)
});

const MatchingProfilesTable = ({ candidateList = [], onCandidateClick }) => {
  const preparedData = useMemo(() => candidateList.map(item => [...Object.values(candidateListMapper(item))]), [candidateList]);
  const handleOnRowClick = useCallback(
    /**
     *
     * @param {string[]} rowData
     */
    rowData => {
      onCandidateClick(rowData[0]);
    },

    [onCandidateClick]
  );

  return (
    <div className="h-100 pt-2">
      <SafeMuiDatatable
        title={
          <Box display="flex">
            <Typography variant="h6">{text.tableTitle}</Typography>
          </Box>
        }
        tableName="matchingProfilesTable"
        onRowClick={handleOnRowClick}
        columns={matchingProfilesColumns.DEFAULT_COLUMNS}
        data={preparedData || []}
        muiTheme={muiTheme}
      />
    </div>
  );
};

MatchingProfilesTable.defaultProps = {
  onCandidateClick: () => {}
};

MatchingProfilesTable.propTypes = {
  candidateList: PropTypes.array.isRequired,
  onCandidateClick: PropTypes.func
};

export default MatchingProfilesTable;
